import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { MetricsDisplayGridRowDataFragmentGql } from './MetricsDisplayGridRowDataFragmentGql';

export const VirtualConnectionTableDownstreamMetricsQueryGql: DocumentNode = gql`
query VirtualConnectionTableDownstreamMetricsQuery(
  $vizportalUrlId: String!,
  $first: Int!,
  $offset:
  Int!,
  $orderBy: MetricSortOrder!
) {
  virtualConnectionTables(filter: { vizportalUrlId: $vizportalUrlId }) {
    downstreamMetricsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...MetricsDisplayGridRowDataFragment
      }
    }
  }
}
${MetricsDisplayGridRowDataFragmentGql}
`;
